import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-67ccf708")

_pushScopeId("data-v-67ccf708")
const _hoisted_1 = {
  key: 0,
  class: "p-d-flex p-flex-column p-jc-center p-ai-center",
  style: {"min-height":"40vh"}
}
const _hoisted_2 = { style: {"min-height":"35vh","width":"30vw"} }
const _hoisted_3 = {
  key: 1,
  style: {"min-height":"30vh"},
  ref: "scrollComponent"
}
const _hoisted_4 = { class: "p-d-flex p-pb-3" }
const _hoisted_5 = { class: "sub-tabview" }
const _hoisted_6 = {
  key: 0,
  class: "p-grid"
}
const _hoisted_7 = { class: "p-col-6 p-col-sm-12" }
const _hoisted_8 = { class: "p-datatable p-datatable-sm" }
const _hoisted_9 = {
  class: "p-datatable-table",
  style: {"width":"100%"}
}
const _hoisted_10 = { class: "p-datatable-tbody" }
const _hoisted_11 = { class: "p-text-bold" }
const _hoisted_12 = { class: "p-text-bold" }
const _hoisted_13 = { class: "p-col-6 p-col-sm-12" }
const _hoisted_14 = { class: "p-datatable p-datatable-sm" }
const _hoisted_15 = {
  class: "p-datatable-table",
  style: {"width":"100%"}
}
const _hoisted_16 = { class: "p-datatable-tbody" }
const _hoisted_17 = { class: "p-text-bold" }
const _hoisted_18 = { class: "p-text-bold" }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { key: 2 }
const _hoisted_21 = {
  key: 0,
  class: "p-d-flex p-jc-center"
}
const _hoisted_22 = { class: "p-grid" }
const _hoisted_23 = { class: "p-col-6" }
const _hoisted_24 = {
  key: 0,
  class: "p-grid"
}
const _hoisted_25 = {
  key: 0,
  class: "p-col-12"
}
const _hoisted_26 = { class: "p-text-right" }
const _hoisted_27 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_28 = {
  key: 0,
  class: "p-col-3"
}
const _hoisted_29 = { class: "p-text-right" }
const _hoisted_30 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_31 = { class: "p-col-12" }
const _hoisted_32 = { key: 3 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_EDARunning = _resolveComponent("EDARunning")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_Button = _resolveComponent("Button")!
  const _component_DatasourceEDAVariableDetail = _resolveComponent("DatasourceEDAVariableDetail")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Distribution = _resolveComponent("Distribution")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_DataSizeHistory = _resolveComponent("DataSizeHistory")!

  return (_ctx.loadingDatasourceProfile || !_ctx.edaFinished)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_EDARunning),
          _createVNode(_component_ProgressBar, {
            mode: "indeterminate",
            style: {"height":"0.5em"}
          })
        ]),
        _createVNode("h5", null, _toDisplayString(_ctx.$t("datasource.eda.analyzing.title")), 1),
        _createVNode("span", null, _toDisplayString(_ctx.$t("datasource.eda.analyzing.description")), 1)
      ]))
    : (_openBlock(), _createBlock("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_Button, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.active = 0)),
              class: _ctx.getCssClass(0),
              label: _ctx.$t('datasource.metadata.overview')
            }, null, 8, ["class", "label"]),
            _createVNode(_component_Button, {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.active = 1)),
              class: _ctx.getCssClass(1),
              label: _ctx.$t('datasource.metadata.variables')
            }, null, 8, ["class", "label"]),
            _createVNode(_component_Button, {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.active = 2)),
              class: _ctx.getCssClass(2),
              label: _ctx.$t('datasource.metadata.correlation')
            }, null, 8, ["class", "label"])
          ])
        ]),
        (_ctx.active == 0)
          ? (_openBlock(), _createBlock("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _createVNode("h3", null, _toDisplayString(_ctx.$t("datasource.metadata.dataset_statistics")), 1),
                _createVNode("div", _hoisted_8, [
                  _createVNode("table", _hoisted_9, [
                    _createVNode("tbody", _hoisted_10, [
                      _createVNode("tr", null, [
                        _createVNode("td", _hoisted_11, _toDisplayString(_ctx.$t("datasource.metadata.n_variable")), 1),
                        _createVNode("td", null, _toDisplayString(_ctx.datasourceProfile?.table.n_var), 1)
                      ]),
                      _createVNode("tr", null, [
                        _createVNode("td", _hoisted_12, _toDisplayString(_ctx.$t("datasource.metadata.n_observation")), 1),
                        _createVNode("td", null, _toDisplayString(_ctx.datasourceProfile?.table.n), 1)
                      ]),
                      _createVNode("tr", null, [
                        _createVNode("td", {
                          class: ["p-text-bold", {
                    'p-error': _ctx.datasourceProfile?.table.n_cells_missing > 0,
                  }]
                        }, _toDisplayString(_ctx.$t("datasource.metadata.n_cells_missing")), 3),
                        _createVNode("td", {
                          class: {
                    'p-error': _ctx.datasourceProfile?.table.n_cells_missing > 0,
                  }
                        }, _toDisplayString(_ctx.datasourceProfile?.table.n_cells_missing), 3)
                      ]),
                      _createVNode("tr", null, [
                        _createVNode("td", {
                          class: ["p-text-bold", {
                    'p-error': _ctx.datasourceProfile?.table.n_cells_missing > 0,
                  }]
                        }, _toDisplayString(_ctx.$t("datasource.metadata.p_cells_missing")), 3),
                        _createVNode("td", {
                          class: {
                    'p-error': _ctx.datasourceProfile?.table.n_cells_missing > 0,
                  }
                        }, _toDisplayString((_ctx.datasourceProfile?.table.p_cells_missing * 100).toFixed(2)) + "% ", 3)
                      ])
                    ])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_13, [
                _createVNode("h3", null, _toDisplayString(_ctx.$t("datasource.metadata.variable_types")), 1),
                _createVNode("div", _hoisted_14, [
                  _createVNode("table", _hoisted_15, [
                    _createVNode("tbody", _hoisted_16, [
                      _createVNode("tr", null, [
                        _createVNode("td", _hoisted_17, _toDisplayString(_ctx.$t("datasource.datarole.numeric")), 1),
                        _createVNode("td", null, _toDisplayString(_ctx.datasourceProfile?.table.types.Numeric), 1)
                      ]),
                      _createVNode("tr", null, [
                        _createVNode("td", _hoisted_18, _toDisplayString(_ctx.$t("datasource.datarole.categorical")), 1),
                        _createVNode("td", null, _toDisplayString(_ctx.datasourceProfile?.table.types.Categorical), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.active == 1)
          ? (_openBlock(), _createBlock("div", _hoisted_19, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.variables(_ctx.start, _ctx.end), (key) => {
                return (_openBlock(), _createBlock(_component_DatasourceEDAVariableDetail, {
                  variable: _ctx.datasourceProfile?.variables[key],
                  key: key,
                  name: key
                }, null, 8, ["variable", "name"]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_ctx.active == 2)
          ? (_openBlock(), _createBlock("div", _hoisted_20, [
              (_ctx.datasourceNumericSchemas.length <= 1)
                ? (_openBlock(), _createBlock("div", _hoisted_21, _toDisplayString(_ctx.$t("datasource.metadata.message.no_correlation")), 1))
                : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _createVNode("div", _hoisted_22, [
                      _createVNode("div", _hoisted_23, [
                        _createVNode(_component_Dropdown, {
                          modelValue: _ctx.selectedOption,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectedOption = $event)),
                          options: _ctx.datasourceNumericSchemas,
                          optionLabel: "name",
                          class: "p-mr-2"
                        }, null, 8, ["modelValue", "options"]),
                        _createVNode(_component_Dropdown, {
                          modelValue: _ctx.selectedCompare,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectedCompare = $event)),
                          options: 
                _ctx.datasourceNumericSchemas.filter(
                  (x) => x.name != _ctx.selectedOption.name
                )
              ,
                          showClear: true,
                          optionLabel: "name",
                          placeholder: _ctx.$t('datasource.eda.correlation.compare')
                        }, null, 8, ["modelValue", "options", "placeholder"])
                      ])
                    ]),
                    (_ctx.edaNumeric && _ctx.selectedOption)
                      ? (_openBlock(), _createBlock("div", _hoisted_24, [
                          (_ctx.selectedCompare)
                            ? (_openBlock(), _createBlock("div", _hoisted_25, [
                                _createTextVNode(_toDisplayString(_ctx.selectedCompare.name) + " ", 1),
                                _createVNode(_component_Distribution, {
                                  data: 
                  _ctx.edaNumeric[_ctx.selectedCompare.name] &&
                  _ctx.edaNumeric[_ctx.selectedCompare.name].map((x, i) => [
                    _ctx.edaNumeric[_ctx.selectedOption.name][i],
                    x,
                  ])
                ,
                                  xAxis: _ctx.selectedOption.name,
                                  yAxis: _ctx.selectedCompare.name
                                }, null, 8, ["data", "xAxis", "yAxis"]),
                                _createVNode("div", _hoisted_26, _toDisplayString(_ctx.selectedOption.name), 1),
                                _hoisted_27,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t("datasource.metadata.correlation")) + ": ", 1),
                                _createVNode("b", {
                                  class: { 'p-error': _ctx.correlation[_ctx.selectedCompare.name] < 0 }
                                }, _toDisplayString(_ctx.$toPercentage(_ctx.correlation[_ctx.selectedCompare.name])), 3)
                              ]))
                            : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.edaData(), (name, index) => {
                                  return (_openBlock(), _createBlock(_Fragment, { key: name }, [
                                    (
                  _ctx.edaNumeric[name] && index >= _ctx.offset && index < _ctx.offset + _ctx.rows
                )
                                      ? (_openBlock(), _createBlock("div", _hoisted_28, [
                                          _createTextVNode(_toDisplayString(name) + " ", 1),
                                          _createVNode(_component_Distribution, {
                                            data: 
                    _ctx.edaNumeric[name].map((x, i) => [
                      _ctx.edaNumeric[_ctx.selectedOption.name][i],
                      x,
                    ])
                  ,
                                            xAxis: _ctx.selectedOption.name,
                                            yAxis: name
                                          }, null, 8, ["data", "xAxis", "yAxis"]),
                                          _createVNode("div", _hoisted_29, _toDisplayString(_ctx.selectedOption.name), 1),
                                          _hoisted_30,
                                          _createTextVNode(" " + _toDisplayString(_ctx.$t("datasource.metadata.correlation")) + ": ", 1),
                                          _createVNode("b", {
                                            class: {
                    'p-error': _ctx.correlation[name] < 0,
                    'p-text-success': _ctx.correlation[name] > 0,
                  }
                                          }, _toDisplayString(_ctx.$toPercentage(_ctx.correlation[name])), 3)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                }), 128)),
                                _createVNode("div", _hoisted_31, [
                                  _createVNode(_component_Paginator, {
                                    first: _ctx.offset,
                                    "onUpdate:first": _cache[6] || (_cache[6] = ($event: any) => (_ctx.offset = $event)),
                                    rows: _ctx.rows,
                                    "onUpdate:rows": _cache[7] || (_cache[7] = ($event: any) => (_ctx.rows = $event)),
                                    totalRecords: _ctx.datasourceNumericSchemas.length - 1,
                                    rowsPerPageOptions: [8, 16, 24]
                                  }, null, 8, ["first", "rows", "totalRecords"])
                                ])
                              ], 64))
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
            ]))
          : _createCommentVNode("", true),
        (_ctx.active == 3)
          ? (_openBlock(), _createBlock("div", _hoisted_32, [
              _createVNode(_component_DataSizeHistory, {
                id: _ctx.id,
                workspaceId: _ctx.workspaceId
              }, null, 8, ["id", "workspaceId"])
            ]))
          : _createCommentVNode("", true)
      ], 512))
})